import { useMemo } from 'react'
import {
  ClientLayout,
  VirtualizedMapGrid as View,
  virtualizedMapGridConfig
} from 'ui-components'

import { useInfiniteSearchMaps } from '~map-search/queries/useSearchMaps'

export const initialNumToRender = virtualizedMapGridConfig.itemsPerRow * 3
export const itemsPerRow = virtualizedMapGridConfig.itemsPerRow

const VirtualizedMapGrid = (props) => {
  const { id, data, isLoading, hasNextPage, fetchNextPage } =
    useInfiniteSearchMaps(initialNumToRender, itemsPerRow)

  const handleEndReached = async () => {
    if (!hasNextPage) return
    await fetchNextPage()
  }

  const items = useMemo(
    () => data?.pages?.flatMap((page) => page?.searchMaps.items || []) || [],
    [data?.pages]
  )

  return (
    <ClientLayout>
      <View
        {...props}
        id={id}
        loading={isLoading}
        items={items}
        hasMoreItems={hasNextPage}
        onEndReached={handleEndReached}
      />
    </ClientLayout>
  )
}

export { VirtualizedMapGrid }
